import { render, staticRenderFns } from "./ConfirmJournalApproval.vue?vue&type=template&id=4a6b9f7d&"
import script from "./ConfirmJournalApproval.vue?vue&type=script&lang=js&"
export * from "./ConfirmJournalApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports